/**
 * Returns the base URL for API calls.
 * - For localhost: uses process.env.REACT_APP_PORTURL (for development)
 * - For other environments: uses window.location.origin (dynamic URL)
 */
export const getBaseUrl = () => {
  const isLocalhost = 
    window.location.hostname === 'localhost' || 
    window.location.hostname === '127.0.0.1';
  
  if (isLocalhost) {
    return process.env.REACT_APP_PORTURL || 'http://localhost:3000';
  }
  
  return window.location.origin;
};

export default getBaseUrl;
